// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.earthwood-layout {
    display: flex;
    min-height: 100vh;
    width: 100%;
}
.pagination .active .page-link { background:#f40; border-color:#f40; color:#fff; }

.services-table-wrapper .MuiTablePagination-root {
    padding: 8px 16px;
    color: #333;
}

.services-table-wrapper .MuiTablePagination-toolbar {
    min-height: 52px;
    gap: 12px;
}

.services-table-wrapper .MuiTablePagination-selectLabel,
.services-table-wrapper .MuiTablePagination-displayedRows {
    margin: 0;
    font-size: 0.875rem;
    color: #555;
}

.services-table-wrapper .MuiTablePagination-actions button {
    color: #f40;
}

.services-table-wrapper .MuiTablePagination-actions button.Mui-disabled {
    color: rgba(0, 0, 0, 0.26);
}

.services-table-wrapper .MuiTablePagination-select {
    padding-right: 24px;
}

.leftbar-wrapper {
    width: 250px;
    flex-shrink: 0;
}

.earthwood-user-list {
    flex-grow: 1;
    padding: 20px;
    overflow-x: auto;
    width: calc(100% - 250px);
}

@media (max-width: 768px) {
    .leftbar-wrapper {
        width: 100%;
    }

    .earthwood-user-list {
        width: 100%;
        padding: 10px;
    }

    .earthwood-layout {
        flex-direction: column;
    }
}


/****************************************************** User Detail CSS *******************************************************/


.user-detail-container {
    padding: 20px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.user-header h2 {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 15px;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    font-size: 14px;
}

/* .tab-style .nav-link {
    color: black;
}

.tab-style .nav-link.active {
    background-color: #FDE802;
    border-radius: 5px;
} */

/* Style the tab nav items */
.tab-style .nav-item {
  margin-right: 20px;
}

.tab-style .nav-link {
  color: #333;
  border: none;
  border-bottom: 3px solid transparent;
  background: none;
  font-weight: 500;
  font-size: 16px;
  padding: 10px 15px;
}

.tab-style .nav-link.active {
  color: #FF4400;
  border-bottom: 3px solid #FF4400;
  background-color: transparent;
}


.tab-content-area {
    padding: 15px;
    border: 1px solid #dee2e6;
    border-radius: 5px;
    background: #f9f9f9;
}

@media (max-width: 768px) {
    .info-grid {
        grid-template-columns: 1fr;
    }

    .user-header {
        flex-direction: column;
    }
}


.tab-content-area {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
}

.tab-content-area h5 {
    font-weight: 600;
    border-bottom: 1px solid #ccc;
    padding-bottom: 8px;
}

.tab-content-area .row>div {
    margin-bottom: 10px;
    font-size: 14px;
}

.basic-detail {
    background: #d6e1ea;
    border-radius: 87px;
    height: 39px;
    padding: 10px;
    margin: 10p;
}
.basic-user-detail {
    background: #FF4400;
    border-radius: 87px;
    height: 39px;
    padding: 10px;
    margin: 10p;
    padding-left: 20px;
}
.underline-text {
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;
  margin-bottom: 12px;
}

/* .tab-content-area .row {
    background: #f1f6fa;
    border-radius: 12px;
    padding: 10px;
} */`, "",{"version":3,"sources":["webpack://./src/assets/css/earthwooduser.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;AACA,iCAAiC,eAAe,EAAE,iBAAiB,EAAE,UAAU,EAAE;;AAEjF;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;;IAEI,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA,+HAA+H;;;AAG/H;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,eAAe;AACnB;;AAEA;;;;;;;GAOG;;AAEH,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,6BAA6B;AAC/B;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;GAIG","sourcesContent":[".earthwood-layout {\n    display: flex;\n    min-height: 100vh;\n    width: 100%;\n}\n.pagination .active .page-link { background:#f40; border-color:#f40; color:#fff; }\n\n.services-table-wrapper .MuiTablePagination-root {\n    padding: 8px 16px;\n    color: #333;\n}\n\n.services-table-wrapper .MuiTablePagination-toolbar {\n    min-height: 52px;\n    gap: 12px;\n}\n\n.services-table-wrapper .MuiTablePagination-selectLabel,\n.services-table-wrapper .MuiTablePagination-displayedRows {\n    margin: 0;\n    font-size: 0.875rem;\n    color: #555;\n}\n\n.services-table-wrapper .MuiTablePagination-actions button {\n    color: #f40;\n}\n\n.services-table-wrapper .MuiTablePagination-actions button.Mui-disabled {\n    color: rgba(0, 0, 0, 0.26);\n}\n\n.services-table-wrapper .MuiTablePagination-select {\n    padding-right: 24px;\n}\n\n.leftbar-wrapper {\n    width: 250px;\n    flex-shrink: 0;\n}\n\n.earthwood-user-list {\n    flex-grow: 1;\n    padding: 20px;\n    overflow-x: auto;\n    width: calc(100% - 250px);\n}\n\n@media (max-width: 768px) {\n    .leftbar-wrapper {\n        width: 100%;\n    }\n\n    .earthwood-user-list {\n        width: 100%;\n        padding: 10px;\n    }\n\n    .earthwood-layout {\n        flex-direction: column;\n    }\n}\n\n\n/****************************************************** User Detail CSS *******************************************************/\n\n\n.user-detail-container {\n    padding: 20px;\n    background: #fff;\n    border-radius: 6px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.user-header h2 {\n    font-size: 22px;\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 10px;\n    font-size: 14px;\n}\n\n/* .tab-style .nav-link {\n    color: black;\n}\n\n.tab-style .nav-link.active {\n    background-color: #FDE802;\n    border-radius: 5px;\n} */\n\n/* Style the tab nav items */\n.tab-style .nav-item {\n  margin-right: 20px;\n}\n\n.tab-style .nav-link {\n  color: #333;\n  border: none;\n  border-bottom: 3px solid transparent;\n  background: none;\n  font-weight: 500;\n  font-size: 16px;\n  padding: 10px 15px;\n}\n\n.tab-style .nav-link.active {\n  color: #FF4400;\n  border-bottom: 3px solid #FF4400;\n  background-color: transparent;\n}\n\n\n.tab-content-area {\n    padding: 15px;\n    border: 1px solid #dee2e6;\n    border-radius: 5px;\n    background: #f9f9f9;\n}\n\n@media (max-width: 768px) {\n    .info-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .user-header {\n        flex-direction: column;\n    }\n}\n\n\n.tab-content-area {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.tab-content-area h5 {\n    font-weight: 600;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 8px;\n}\n\n.tab-content-area .row>div {\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.basic-detail {\n    background: #d6e1ea;\n    border-radius: 87px;\n    height: 39px;\n    padding: 10px;\n    margin: 10p;\n}\n.basic-user-detail {\n    background: #FF4400;\n    border-radius: 87px;\n    height: 39px;\n    padding: 10px;\n    margin: 10p;\n    padding-left: 20px;\n}\n.underline-text {\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 4px;\n  margin-bottom: 12px;\n}\n\n/* .tab-content-area .row {\n    background: #f1f6fa;\n    border-radius: 12px;\n    padding: 10px;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
